export class User {

    public siret: string;
    public service: string;
    public raisonSociale: string;

    /**
     * Compare two users by siret, then by service.
     */
    public static compare(user: User, otherUser: User): number {
        if (user.siret === null) {
            return 1
        } else if(otherUser.siret === null) {
            return -1
        }

        let compareBySiret = user.siret.localeCompare(otherUser.siret);
        
        if (compareBySiret !== 0) {
            return compareBySiret;
        } else {
            return User.compareByService(user, otherUser);
        }
    }

    private static compareByService(user: User, otherUser: User): number {
        if (user.service === null) {
            return 1
        } else if(otherUser.service === null) {
            return -1
        }

        return user.service.localeCompare(otherUser.service);
    }

    /**
     * Check if a User is equal to another.
     * 
     * The raison sociale is informative and ignored in the comparison.
     */
    public equals(other: any): boolean {
        if (this === other) return true

        if (! (other instanceof User)) return false

        return (this.siret === other.siret && this.service === other.service)
    }

    /**
     * A placeholder for equals for JSON objects that do not have it.
     * Fix HttpService.instanciate and remove altogether in favor of equals
     * 
     * @deprecated Use (non-static) equals instead
     * 
     * @param user a user
     * @param other another user
     * @returns true if and only if the users are equal.
     */
    // TODO Remove and use equals instead.
    public static equals(user: User, other: any) {
        if (user === other) return true

        return (user.siret === other.siret && user.service === other.service)
    }
}
